import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiInbox } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import Panel, { Skeleton, Vacio } from './Panel';
import FilaAjuste from '../../../../components/ui/FilaAjuste';
import i18n from '../../../../i18n';
import { ROL_LABELS, ESTADO_LABELS, DEPTO_LABELS } from '../../../../constants/usuarios';

const CLAVES_ESTADO = ['abierto', 'retenido', 'cerrado'];
const CLAVES_CAMPO = ['role', 'estado', 'dpto_tecnico', 'contrasena'];

const valorLabel = (campo, valor) => {
  if (valor === null || valor === undefined) return '—';
  if (campo === 'role') return ROL_LABELS[valor] || valor;
  if (campo === 'estado') return ESTADO_LABELS[valor] || valor;
  if (campo === 'dpto_tecnico') return DEPTO_LABELS[valor] || valor;
  return valor;
};

const fechaCorta = (fecha) => new Date(fecha).toLocaleDateString(i18n.language, {
  day: 'numeric', month: 'short',
});

const VISIBLES_INICIALMENTE = 6;
const TICKETS_VISIBLES = 6;

/**
 * Actividad del usuario: sus últimos tickets y el historial de cambios
 * sensibles de la cuenta. Ambos son de solo lectura, por eso van juntos en
 * una misma hoja, cada uno en su fila.
 */
const PanelActividad = ({
  tickets, cargandoTickets, onVerTodos,
  auditoria, cargandoAuditoria, mostrarAuditoria,
}) => {
  const { t } = useTranslation();
  const [expandido, setExpandido] = useState(false);
  const etiquetaEstado = (clave) => (CLAVES_ESTADO.includes(clave) ? t(`perfilUsuario.estados.${clave}`) : clave);
  const etiquetaCampo = (clave) => (CLAVES_CAMPO.includes(clave) ? t(`perfilUsuario.campos.${clave}`) : clave);

  const visibles = expandido ? auditoria : auditoria.slice(0, VISIBLES_INICIALMENTE);
  const ocultos = auditoria.length - visibles.length;

  return (
    <Panel>
      <FilaAjuste titulo={t('perfilUsuario.ticketsDelUsuario')} texto={t('perfilUsuario.filas.ticketsTexto')} ancho>
        {cargandoTickets ? (
          <Skeleton filas={4} />
        ) : tickets.length === 0 ? (
          <Vacio icono={FiInbox}>{t('perfilUsuario.sinTicketsCreados')}</Vacio>
        ) : (
          <>
            <div className="pu-tickets">
              {tickets.slice(0, TICKETS_VISIBLES).map((t) => (
                <Link key={t.identificador} to={`/ticket/${t.identificador}`} className="pu-ticket">
                  <span className="pu-ticket-asunto">{t.asunto}</span>
                  <span className="pu-ticket-fecha">{fechaCorta(t.createdAt)}</span>
                  {/* Con un estado desconocido la pastilla salía vacía: se cae al
                      propio valor para que siempre diga algo. */}
                  <span className={`pu-ticket-estado ${t.estado_del_ticket || ''}`}>
                    {etiquetaEstado(t.estado_del_ticket) || t('perfilUsuario.sinEstado')}
                  </span>
                </Link>
              ))}
            </div>

            <button type="button" className="pu-enlace-mas" onClick={onVerTodos}>
              {t('perfilUsuario.verTicketsEnPanel', { count: tickets.length })}
            </button>
          </>
        )}
      </FilaAjuste>

      {mostrarAuditoria && (
        <FilaAjuste titulo={t('perfilUsuario.historialCambios')} texto={t('perfilUsuario.filas.historialTexto')} ancho>
          {cargandoAuditoria ? (
            <Skeleton filas={3} />
          ) : auditoria.length === 0 ? (
            <Vacio icono={FiInbox}>{t('perfilUsuario.sinCambiosRegistrados')}</Vacio>
          ) : (
            <>
              <div className="pu-timeline">
                {visibles.map((registro) => (
                  <div key={registro.id} className="pu-timeline-item">
                    <p className="pu-timeline-texto">
                      <strong>{etiquetaCampo(registro.campo)}</strong>
                      {registro.campo === 'contrasena' ? (
                        t('perfilUsuario.reseteada')
                      ) : (
                        <>
                          : {valorLabel(registro.campo, registro.valor_anterior)}
                          {' → '}
                          <b>{valorLabel(registro.campo, registro.valor_nuevo)}</b>
                        </>
                      )}
                      <span className="pu-timeline-meta">
                        {t('perfilUsuario.filas.cambioPor', {
                          usuario: registro.realizado_por,
                          fecha: new Date(registro.createdAt).toLocaleString(i18n.language, {
                            day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
                          }),
                        })}
                      </span>
                    </p>
                  </div>
                ))}
              </div>

              {(ocultos > 0 || expandido) && (
                <button
                  type="button"
                  className="pu-enlace-mas"
                  onClick={() => setExpandido((v) => !v)}
                >
                  {expandido ? t('perfilUsuario.verMenos') : t('perfilUsuario.verCambiosMas', { count: ocultos })}
                </button>
              )}
            </>
          )}
        </FilaAjuste>
      )}
    </Panel>
  );
};

export default PanelActividad;
